import React from "react";
import { getCloudinaryUrl, isEmpty } from "@swiggy-private/js-utils";

import { ScreenNames } from "@swiggy-private/portal-dineout-context";
import Track from "./Track";
import type { ITrackProps } from "./types";
import { ErrorPageWrapper } from "../BillSummary/styles";
import { EMPTY_TRACK_SCREEN } from "../constants/track";
import { ErrorComponent } from "../ErrorComponent";
import { useAnalytics } from "../hooks";
import { TabContentLoadingSkeleton } from "../Skeleton";

const TrackPage = ({
    headers,
    sdk,
    clickAnalytics: defaultClickAnalytics,
    impressionAnalytics: defaultImpressionAnalytics,
    cards,
    popupConfigs,
    showEmptyOrderError,
    handleErrorCtaClick,
    genericOnclick,
    onInvalidWidget,
    onWidgetError,
    onEmptyPage,
    screenName,
}: ITrackProps) => {
    const { impressionAnalytics, clickAnalytics } = useAnalytics({
        screenName: ScreenNames.TRACK,
        defaultImpressionAnalytics,
        defaultClickAnalytics,
    });

    if (showEmptyOrderError) {
        return (
            <ErrorPageWrapper>
                <ErrorComponent
                    {...EMPTY_TRACK_SCREEN}
                    onCtaClick={handleErrorCtaClick}
                    imgSrc={getCloudinaryUrl(EMPTY_TRACK_SCREEN.img, {
                        width: 220 * 2,
                        height: 200 * 2,
                    })}
                    showFullPage={false}
                />
            </ErrorPageWrapper>
        );
    }

    if (isEmpty(cards)) {
        return <TabContentLoadingSkeleton />;
    }

    return (
        <Track
            cards={cards}
            popupConfigs={popupConfigs}
            sdk={sdk}
            headers={headers}
            clickAnalytics={clickAnalytics}
            impressionAnalytics={impressionAnalytics}
            genericOnclick={genericOnclick}
            onEmptyPage={onEmptyPage}
            onInvalidWidget={onInvalidWidget}
            onWidgetError={onWidgetError}
            screenName={screenName}
        />
    );
};

export default TrackPage;
